<template>
    <a-drawer
      :title="'留学生信息-'+actionName"
      placement="right"
      :closable="false"
      :visible="visible"
      @close="onClose"
      width="30%"
    >
        <div class="input-box">
            <p>学号：</p>
            <a-input class="input" v-model="info.studentNo" :disabled="actionName=='查看'"/>
        </div>
        <div class="input-box">
            <p>英文名：</p>
            <a-input class="input" :disabled="actionName=='查看'" v-model="info.studentEnglishName" />
        </div>
        <div class="input-box">
            <p>中文名：</p>
            <a-input class="input" :disabled="actionName=='查看'" v-model="info.studentChName" />
        </div>
        <div class="input-box">
            <p>国籍：</p>
            <a-select 
                class="input" 
                allowClear 
                show-search 
                :filter-option="filterOption"
                 v-model="info.nationalityCode"
                :disabled="actionName=='查看'">
                <a-select-option v-for="(item,index) in gjArr" :key="index" :value="item.dataCode">{{item.dataName}}</a-select-option>
            </a-select>
        </div>
        <div class="input-box">
            <p>性别：</p>
            <a-select class="input" allowClear v-model="info.genderCode" :disabled="actionName=='查看'">
                <a-select-option v-for="(item,index) in xbArr" :key="index" :value="item.dataCode">{{item.dataName}}</a-select-option>
            </a-select>
        </div>
        <div class="input-box">
            <p>出生日期：</p>
            <a-date-picker class="input" v-model="info.birthday" @change="(date, dateString)=>{info.birthday=dateString}" :disabled="actionName=='查看'"/>
        </div>
        <div class="input-box">
            <p>护照号码：</p>
            <a-input class="input" :disabled="actionName=='查看'" v-model="info.passportId" />
        </div>
        <div class="input-box">
            <p>学习截止日期：</p>
            <a-date-picker class="input" v-model="info.learningDeadline" @change="(date, dateString)=>{info.learningDeadline=dateString}" :disabled="actionName=='查看'"/>
        </div>
        <div class="input-box">
            <p>所在院校：</p>
            <a-input class="input" :disabled="actionName=='查看'" v-model="info.collegeName" />
        </div>
        <div class="input-box">
            <p>专业学院：</p>
            <a-select 
                class="input" 
                allowClear 
                show-search 
                :filter-option="filterOption"
                 v-model="info.majorDepartmentCode"
                :disabled="actionName=='查看'">
                <a-select-option v-for="(item,index) in xyArr" :key="index" :value="item.dataCode">{{item.dataName}}</a-select-option>
            </a-select>
        </div>
        <div class="input-box">
            <p>专业名称：</p>
            <a-input class="input" :disabled="actionName=='查看'" v-model="info.majorName" />
        </div>
        <div class="input-box">
            <p>学生类别：</p>
            <a-select 
                class="input" 
                allowClear 
                show-search 
                :filter-option="filterOption"
                 v-model="info.studentTypeCode"
                :disabled="actionName=='查看'">
                <a-select-option v-for="(item,index) in xslbArr" :key="index" :value="item.dataCode">{{item.dataName}}</a-select-option>
            </a-select>
        </div>
        <div class="input-box">
            <p>导师：</p>
            <a-select 
                class="input" 
                allowClear
                show-search
                :filter-option="false"
                @search="teacherSearch"
                v-model="info.guideTeacherName"
                @change="teacherChange"
                option-label-prop="label"
                :disabled="actionName=='查看'">
                <a-select-option v-for="(item,index) in jsArr" :key="index" :value="item.teacherId" :label="item.teacherName">{{item.teacherId}}-{{item.teacherName}}</a-select-option>
            </a-select>
        </div>
        <div class="input-box">
            <p>经费来源：</p>
            <a-input-number class="input" :disabled="actionName=='查看'" v-model="info.fundsSource" />
        </div>
        <div class="input-box">
            <p>在沪居住地址：</p>
            <a-textarea class="input" :rows="3" :disabled="actionName=='查看'" v-model="info.shanghaiResidence" />
        </div>
        <div class="input-box">
            <p>手机号码：</p>
            <a-input class="input" :disabled="actionName=='查看'" v-model="info.phoneNumber" />
        </div>
        <div class="input-box">
            <p>学籍状态：</p>
            <a-select 
                class="input" 
                allowClear 
                show-search 
                :filter-option="filterOption"
                 v-model="info.studentStatusCode"
                :disabled="actionName=='查看'">
                <a-select-option v-for="(item,index) in xjztArr" :key="index" :value="item.dataCode">{{item.dataName}}</a-select-option>
            </a-select>
        </div>
        <div class="input-box">
            <p>备注：</p>
            <a-textarea class="input" :rows="4" :disabled="actionName=='查看'" v-model="info.remark" />
        </div>
        <div class="btn-box">
            <a-button type="primary" @click="sub" v-if="actionName!='查看'">提交</a-button>
            <a-button @click="onClose">取消</a-button>
        </div>
    </a-drawer>
</template>

<script>
    import { getDicts } from '@/baseAPI/dictionary'
    import { add,update,info } from '@/baseAPI/international/student'
    import { getTeacher } from '@/baseAPI/facultyTeacher'
    export default {
        name: '',
        components: {
        },
        computed: {},
        data() {
            return {
                actionName:'',
                visible:false,
                id:'',
                info:{
                    studentNo:null,
                    studentEnglishName:null,
                    studentChName:null,
                    nationalityCode:null,
                    genderCode:null,
                    birthday:null,
                    passportId:null,
                    learningDeadline:null,
                    collegeName:null,
                    majorDepartmentCode:null,
                    majorName:null,
                    studentTypeCode:null,
                    guideTeacherName:null,
                    fundsSource:null,
                    shanghaiResidence:null,
                    phoneNumber:null,
                    studentStatusCode:null,
                    remark:null,
                },
                gjArr:[],
                xbArr:[],
                xslbArr:[],
                xjztArr:[],
                jsArr:[],
                xyArr:[],
            }
        },
        mounted () {
        },
        methods:{
            getInfo(){
                getDicts({dataCode:'GJ',status:true}).then(res=>{
                    this.gjArr=res.data.dicts;
                    this.info.nationalityCode=res.data.defaultValue[0]
                })
                getDicts({dataCode:'XB',status:true}).then(res=>{
                    this.xbArr=res.data.dicts;
                    this.info.genderCode=res.data.defaultValue[0]
                })
                getDicts({dataCode:'XSLB',status:true}).then(res=>{
                    this.xslbArr=res.data.dicts;
                    this.info.studentTypeCode=res.data.defaultValue[0]
                })
                getDicts({dataCode:'XJZT',status:true}).then(res=>{
                    this.xjztArr=res.data.dicts;
                    this.info.studentStatusCode=res.data.defaultValue[0]
                })
                getDicts({dataCode:'XY',status:true}).then(res=>{
                    this.xyArr=res.data.dicts;
                    this.info.majorDepartmentCode=res.data.defaultValue[0]
                })
                if(this.actionName!='新增'){
                    setTimeout(()=>{
                        info(this.id).then(res=>{
                            this.info=res.data;
                            this.teacherSearch(this.info.courseDirectorNo)
                        })
                    },500)
                }
            },
            showDrawer(name,id){
                this.id=id;
                this.actionName=name;
                this.getInfo();
                this.visible=true;
            },
            onClose() {
                this.info={
                    studentNo:null,
                    studentEnglishName:null,
                    studentChName:null,
                    nationalityCode:null,
                    genderCode:null,
                    birthday:null,
                    passportId:null,
                    learningDeadline:null,
                    collegeName:null,
                    majorDepartmentCode:null,
                    majorName:null,
                    studentTypeCode:null,
                    guideTeacherName:null,
                    fundsSource:null,
                    shanghaiResidence:null,
                    phoneNumber:null,
                    studentStatusCode:null,
                    remark:null,
                };
                this.visible = false;
                this.$parent.fetch()
            },
            handSearch(value){
                if(value!=''){
                    this.info.consProjectTypeCode=value
                }
            },
            filterOption(input, option) {
                return (
                    option.componentOptions.children[0].text.toLowerCase().indexOf(input.toLowerCase()) >= 0
                );
            },
            sub(){
                var isSub=true;
                var arr=['remark','approvalStatus','courseAttrName']
                for(let key in this.info){
                    if(arr.indexOf(key)<0){
                        if(this.info[key]==null||this.info[key]===''){
                            isSub=false;
                            break;
                        }
                    }
                }
                if(isSub){
                    if(this.actionName=='新增'){
                        add(this.info).then(res=>{
                            if(res.data.success){
                                this.$notification['success']({
                                    message: '成功',
                                    description:'新增留学生信息成功',
                                });
                                this.onClose()
                            }else{
                                this.$notification['error']({
                                    message: '失败',
                                    description:res.data.errorMessage,
                                });
                            }
                        })
                    }else{
                        update(this.info).then(res=>{
                            if(res.data.success){
                                this.$notification['success']({
                                    message: '成功',
                                    description:'修改留学生信息成功',
                                });
                                this.onClose()
                            }else{
                                this.$notification['error']({
                                    message: '失败',
                                    description:res.data.errorMessage,
                                });
                            }
                        })
                    }
                }else{
                    this.$notification['warning']({
                        message: '警告',
                        description:'请填写完整！',
                    });
                }
            },
            teacherSearch(value){
                getTeacher({teacherName:value}).then(res=>{
                    this.jsArr=res.data;
                })
            },
            teacherChange(value){
                for(let i=0;i<this.jsArr.length;i++){
                    if(this.jsArr[i].teacherId==value){
                        this.info.guideTeacherName=this.jsArr[i].teacherName
                    }
                }
            },

        }
    }
</script>

<style scoped>
    .ant-drawer >>> .ant-drawer-header{
        background-color: #245086;
        border-radius: 0;
    }
    .ant-drawer >>> .ant-drawer-title{
        color: #fff;
        font-weight: bold;
        letter-spacing: 1px;
        font-size: 1.1rem;
    }
    .input-box{
        display: flex;
        line-height: 32px;
        margin-bottom: 1.5rem;
        position: relative;
    }
    .input-box p{
        width: 8rem;
        text-align: right;
    }
    .input-box .input{
        width: calc(100% - 8rem);
    }
    .input-box .tips{
        width: calc(100% - 8rem);
        position: absolute;
        right: 0;
        top: 100%;
        font-size: 13px;
        line-height: 20px;
        color: #1890ff;
    }
    .btn-box{
        position: absolute;
        bottom: 0;
        left: 0;
        width: 100%;
        text-align: right;
        padding-bottom: 1rem;
        background-color: #fff;
    }
    .btn-box .ant-btn{
        margin-right: 2rem;
    }
    .input>>>.ant-input[disabled],.ant-input[disabled],.ant-select-disabled,.ant-input-number-disabled{
        color: rgba(0, 0, 0, 0.65);
        background-color: transparent;
    }
    .ant-select-disabled >>> .ant-select-selection{
        background-color: transparent;
    }

</style>
